<div class="space-y-6">
  <app-page-header
    [title]="'invoices.mesFactures' | t"
    [subtitle]="'invoices.toutesLesFacturesLiees' | t"
  />

  <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <!-- Tabs Toutes / En retard -->
    <div class="border-b border-gray-200 px-5 py-3 dark:border-gray-800">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="inline-flex rounded-lg border border-gray-200 p-1 dark:border-gray-700">
          <button
            type="button"
            (click)="switchTab('all')"
            class="rounded-md px-3 py-1.5 text-xs font-medium transition"
            [class.bg-brand-500]="tab() === 'all'"
            [class.text-white]="tab() === 'all'"
            [class.text-gray-600]="tab() !== 'all'"
            [class.dark:text-gray-400]="tab() !== 'all'"
          >
            {{ 'invoices.toutes' | t }}
          </button>
          <button
            type="button"
            (click)="switchTab('overdue')"
            class="rounded-md px-3 py-1.5 text-xs font-medium transition"
            [class.bg-error-500]="tab() === 'overdue'"
            [class.text-white]="tab() === 'overdue'"
            [class.text-gray-600]="tab() !== 'overdue'"
            [class.dark:text-gray-400]="tab() !== 'overdue'"
          >
            En retard
          </button>
        </div>
        <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
          <span>{{ 'invoices.parPage' | t }}</span>
          <div class="w-20">
            <app-pretty-select
              [options]="pageSizeOptions"
              [ngModel]="size()"
              (ngModelChange)="changeSize($event ?? 10)"
              placeholder="10"
            />
          </div>
        </div>
      </div>
    </div>

    @if (error() || (loading() && invoices().length === 0) || invoices().length === 0) {
      <app-data-state
        [loading]="loading()"
        [error]="error()"
        [empty]="!loading() && !error() && invoices().length === 0"
        [loadingMessage]="'invoices.chargementDesFactures' | t"
        [emptyMessage]="tab() === 'overdue' ? 'Aucune facture en retard.' : 'Aucune facture pour le moment.'"
        (retry)="load()"
      />
    } @else {
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
          <thead class="bg-gray-50 dark:bg-white/[0.02]">
            <tr>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.facture' | t }}</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.location' | t }}</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.emise' | t }}</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.echeance' | t }}</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.statut' | t }}</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'invoices.montant' | t }}</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-800 dark:bg-transparent">
            @for (inv of invoices(); track inv.id) {
              <tr class="transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                <td class="whitespace-nowrap px-5 py-4">
                  <a [routerLink]="['/my-invoices', inv.id]" class="text-sm font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">
                    {{ inv.invoiceNumber }}
                  </a>
                  @if (inv.paymentReference) {
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'invoices.ref' | t: { ref: inv.paymentReference } }}</p>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4">
                  @if (inv.rental; as r) {
                    <a [routerLink]="['/my-rentals', r.id]" class="text-sm text-gray-700 hover:text-brand-700 dark:text-gray-300 dark:hover:text-brand-400">
                      Location #{{ r.id }}
                    </a>
                    @if (r.vehicle?.licencePlate) {
                      <p class="font-mono text-xs text-gray-500 dark:text-gray-400">{{ r.vehicle?.licencePlate }}</p>
                    }
                  } @else {
                    <span class="text-xs text-gray-400">—</span>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                  {{ inv.issueDate | ldate: 'dd/MM/yy' }}
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-sm">
                  <span [class.text-error-700]="inv.status === 'OVERDUE'" [class.dark:text-error-400]="inv.status === 'OVERDUE'" [class.text-gray-700]="inv.status !== 'OVERDUE'" [class.dark:text-gray-300]="inv.status !== 'OVERDUE'">
                    {{ inv.dueDate | ldate: 'dd/MM/yy' }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-5 py-4">
                  <span
                    class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
                    [class.bg-brand-50]="statusMeta[inv.status].palette === 'brand'"
                    [class.text-brand-700]="statusMeta[inv.status].palette === 'brand'"
                    [class.dark:bg-brand-500/15]="statusMeta[inv.status].palette === 'brand'"
                    [class.dark:text-brand-400]="statusMeta[inv.status].palette === 'brand'"
                    [class.bg-blue-light-50]="statusMeta[inv.status].palette === 'blue-light'"
                    [class.text-blue-light-700]="statusMeta[inv.status].palette === 'blue-light'"
                    [class.dark:bg-blue-light-500/15]="statusMeta[inv.status].palette === 'blue-light'"
                    [class.dark:text-blue-light-400]="statusMeta[inv.status].palette === 'blue-light'"
                    [class.bg-warning-50]="statusMeta[inv.status].palette === 'warning'"
                    [class.text-warning-700]="statusMeta[inv.status].palette === 'warning'"
                    [class.dark:bg-warning-500/15]="statusMeta[inv.status].palette === 'warning'"
                    [class.dark:text-warning-400]="statusMeta[inv.status].palette === 'warning'"
                    [class.bg-gray-100]="statusMeta[inv.status].palette === 'gray'"
                    [class.text-gray-700]="statusMeta[inv.status].palette === 'gray'"
                    [class.dark:bg-gray-800]="statusMeta[inv.status].palette === 'gray'"
                    [class.dark:text-gray-300]="statusMeta[inv.status].palette === 'gray'"
                    [class.bg-error-50]="statusMeta[inv.status].palette === 'error'"
                    [class.text-error-700]="statusMeta[inv.status].palette === 'error'"
                    [class.dark:bg-error-500/15]="statusMeta[inv.status].palette === 'error'"
                    [class.dark:text-error-400]="statusMeta[inv.status].palette === 'error'"
                  >
                    {{ statusMeta[inv.status].label | t }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right text-sm text-gray-700 dark:text-gray-300">
                  {{ (inv.totalAmount ?? 0) | number:'1.0-0' }} <span class="text-xs text-gray-400">XOF</span>
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right">
                  <a [routerLink]="['/my-invoices', inv.id]" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">{{ 'invoices.voir' | t }}</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (totalPages() > 0) {
        <div class="flex flex-col gap-3 border-t border-gray-200 px-5 py-4 dark:border-gray-800 sm:flex-row sm:items-center sm:justify-between">
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Page {{ page() }} sur {{ totalPages() }} — {{ totalItems() }} facture(s)
          </p>
          <div class="flex flex-wrap items-center gap-1">
            <button type="button" (click)="goToPage(page() - 1)" [disabled]="page() <= 1" class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/5">{{ 'invoices.precedent' | t }}</button>
            @for (n of pageWindow(); track n) {
              <button
                type="button"
                (click)="goToPage(n)"
                class="min-w-[36px] rounded-lg border px-3 py-1.5 text-xs font-medium transition"
                [class.border-brand-500]="n === page()"
                [class.bg-brand-500]="n === page()"
                [class.text-white]="n === page()"
                [class.border-gray-300]="n !== page()"
                [class.text-gray-700]="n !== page()"
                [class.hover:bg-gray-50]="n !== page()"
                [class.dark:border-gray-700]="n !== page()"
                [class.dark:text-gray-400]="n !== page()"
                [class.dark:hover:bg-white/5]="n !== page()"
              >
                {{ n }}
              </button>
            }
            <button type="button" (click)="goToPage(page() + 1)" [disabled]="page() >= totalPages()" class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/5">{{ 'invoices.suivant' | t }}</button>
          </div>
        </div>
      }
    }
  </section>
</div>
